import React, { useContext, useEffect, useRef } from 'react';
import './Search.css'
import DataContext from './DataContext/DataContext';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import useRoutes from '../routes/useRoutes';

const SuggestionsList = () => {
    const {handleSuggestionClick, suggestions, setSuggestions, setQuery, language, query, showSuggestion, setShowSuggestion} = useContext(DataContext);
    const suggestionRef = useRef(null)
    const routes = useRoutes();
    const route = useHistory()


    useEffect(() => {
        const handleOutsideClick = event => {
         // event.preventDefault();
          // console.log(event.target.classList)
          if (suggestionRef.current && !suggestionRef.current.contains(event.target) && (event.target.className !== 'search')) {
            // if(event.target.className === 'imageStyle' || event.target.className === 'select-opt' || event.target.className ==='sBtn-text'){return}
           if(event.target.className === 'search-input' || event.target.className === "suggestions-list"){ return}
            // setSuggestions([]);
            // setQuery("")
            setShowSuggestion(false)
          }
        };
    
        document.addEventListener('mousedown', handleOutsideClick);
    
        return () => {
          document.removeEventListener('mousedown', handleOutsideClick);
        };
      }, []);
    
  return (
    <>
      {/* {suggestions.length > 0 ? ( */}
      {(showSuggestion && query) ? (
        // suggestions.length > 0 ? (
        <ul className="suggestions-list" style={!suggestions.length ?{height: '50px'} :{}} ref={suggestionRef}>
          {/* {(!suggestions.length&& !query) && <li >No record found!</li>} */}
          {suggestions.length > 0 ? suggestions.map((suggestion, index) => (
            <li
              key={index}
              className="suggestion-item"
              onClick={() => {
                // handleSuggestionClick()
                setShowSuggestion(false)
                route.push(suggestion.type==='Dish' ?
                  routes.ppsiRoute(suggestion.id) :
                  routes.ppiRoute(suggestion.id))
              }}
            >
              <div className="suggestion-name">
                {/* <Link to={ suggestion.type==='Dish' ?
                    routes.ppsiRoute(suggestion.id) :
                    routes.ppiRoute(suggestion.id)
                    }> */}
                    {suggestion.info[language].presentationName}
                {/* </Link> */}
              </div>
              <div className="suggestion-category">{suggestion.type}</div>
            </li>
          )) : 
          <>
          {query && <li style={{paddingLeft: '6px'}}>No result found!</li>}
          </>
          
          }
        </ul> ):""}
      
      {/* // ((query && suggestions.length ===0) &&
      //  <ul className="suggestions-list" style={{height: '50px'}} ref={suggestionRef}>
      //   <li >No record found!</li>
      // </ul>
      // )
      // } */}
    </>
  );
};

export default SuggestionsList;
